import { QueryClient } from '@tanstack/react-query';
import {
    persistQueryClient,
  } from '@tanstack/react-query-persist-client'
import {
    createAsyncStoragePersister,
  } from '@tanstack/query-async-storage-persister'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Reuse recent results across route loaders, mounts, focus and reconnect.
            // Live data can override this; mutations and realtime invalidation still refetch.
            staleTime: 5 * 60_000,
            retry: (failureCount) => failureCount < 3,
        },
    },
});

const localStoragePersister = createAsyncStoragePersister({
    storage: window.localStorage,
})
  
// Enable persistence
persistQueryClient({
    queryClient,
    persister: localStoragePersister,
    dehydrateOptions: {
        // Save only queries that match certain keys
        shouldDehydrateQuery: (query) => query.meta?.persist === true,
    }
})
